var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "las_fil pb-3" },
    [
      _c("div", { staticClass: "files_block" }, [
        _vm.head_items.length > 0
          ? _c(
              "div",
              { staticClass: "head_list" },
              _vm._l(_vm.head_items, function (head) {
                return _c("div", { staticClass: "head_item" }, [
                  _c("div", { staticClass: "row doc_title mt-4" }, [
                    _c("div", { staticClass: "col-sm-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "fs-xl",
                          attrs: { for: "is_random_<?= $head->id ?>" },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(head.field_name) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary waves-effect waves-themed",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.edit_head(head)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fal fa-edit" })]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "fs-xl form-control form-control-sm",
                          attrs: { type: "text", disabled: "disabled" },
                          domProps: { value: head.field_val },
                        }),
                      ]),
                    ]),
                  ]),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "parts_inside mt-5" },
          [
            _c("b-table", {
              attrs: {
                "tbody-tr-class": _vm.rowClass,
                "head-variant": "dark",
                items: _vm.parts_items,
                fields: _vm.fields,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("parts_edit_head", { attrs: { doc_id: _vm.mem.id } }),
      _vm._v(" "),
      _c("parts_edit_items", { attrs: { doc_id: _vm.mem.id } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }